import React from 'react';
import { Mail, Phone } from 'lucide-react';

const Contact = () => {
  return (
    <section className="py-12 bg-gray-50">
      {/* Full-width marketing banner above */}
      <div className="w-full mb-10">
        <img
          src="https://customer-assets.emergentagent.com/job_find-twofungis/artifacts/xl34d4lz_ChatGPT%20Image%20Jun%2017%2C%202026%2C%2012_07_03%20PM.png"
          alt="Two Fungis Finishing - From Frame to Finish"
          className="w-full h-auto block"
        />
      </div>

      <div id="contact" className="container mx-auto px-4 sm:px-6 lg:px-8 scroll-mt-32">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-center mb-10">
            <div className="flex flex-col items-center justify-center gap-3 mb-4">
              <img src="https://customer-assets.emergentagent.com/job_okanagan-interiors/artifacts/x3dcmfph_image%20%281%29.png" alt="Two Fungis Finishing" className="h-20 md:h-24 w-auto" />
              <h2 className="text-4xl sm:text-5xl font-bold text-black" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>
                Get in <span className="text-red-600">Touch</span>
              </h2>
            </div>
            <div className="w-24 h-1 bg-red-600 mx-auto mb-6"></div>
            <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto" style={{ fontFamily: 'Open Sans, sans-serif' }}>
              For tender invitations, project consultations, commercial pricing, site meetings or general inquiries — we&apos;re here and happy to talk.
            </p>
            <div className="flex flex-wrap justify-center gap-2 mt-5 max-w-3xl mx-auto">
              {[
                'Tender Invitations',
                'Project Consultations',
                'Commercial Pricing',
                'Site Meetings',
                'General Inquiries',
              ].map((t) => (
                <span key={t} className="px-3 py-1 rounded-full text-xs uppercase tracking-wider text-gray-700 bg-white border border-gray-200" style={{ fontFamily: 'Open Sans, sans-serif' }}>
                  {t}
                </span>
              ))}
            </div>
          </div>

          <div className="max-w-4xl mx-auto">
            {/* Main Contact Card - BLACK background */}
            <div className="bg-black p-12 rounded-xl shadow-2xl text-center mb-12">
              <h3 className="text-3xl font-bold text-white mb-8" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>
                Contact Two Fungis Finishing
              </h3>
              
              <div className="grid md:grid-cols-2 gap-6 mb-6">
                {/* Phone 1 - Scott */}
                <a
                  href="tel:778-268-4920"
                  className="flex flex-col items-center p-6 bg-white rounded-lg hover:bg-gray-100 transition-colors group"
                  data-testid="phone-scott"
                >
                  <div className="p-4 rounded-full mb-4 group-hover:scale-110 transition-transform" style={{ backgroundColor: '#228B22' }}>
                    <Phone className="text-white" size={32} />
                  </div>
                  <p className="text-2xl font-bold text-red-600 mb-1">778-268-4920</p>
                  <p className="font-bold text-black" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>Scott Marshall</p>
                  <p className="text-gray-500 text-sm">Okanagan / Thompson / Fraser Valley</p>
                </a>

                {/* Phone 2 - Beau */}
                <a
                  href="tel:250-327-8202"
                  className="flex flex-col items-center p-6 bg-white rounded-lg hover:bg-gray-100 transition-colors group"
                  data-testid="phone-beau"
                >
                  <div className="p-4 rounded-full mb-4 group-hover:scale-110 transition-transform" style={{ backgroundColor: '#228B22' }}>
                    <Phone className="text-white" size={32} />
                  </div>
                  <p className="text-2xl font-bold text-red-600 mb-1">250-327-8202</p>
                  <p className="font-bold text-black" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>Beau Suprun</p>
                  <p className="text-gray-500 text-sm">Vancouver Island / Lower Mainland</p>
                </a>
              </div>

              {/* Email - slim elongated row spanning full width */}
              <a
                href="mailto:inbox@twofungis.ca"
                className="flex items-center justify-center gap-4 p-4 bg-white rounded-lg hover:bg-gray-100 transition-colors group mb-8"
                data-testid="email-link"
              >
                <div className="p-3 rounded-full group-hover:scale-110 transition-transform flex-shrink-0" style={{ backgroundColor: '#228B22' }}>
                  <Mail className="text-white" size={24} />
                </div>
                <div className="text-left">
                  <p className="text-xl font-bold text-red-600 break-all">inbox@twofungis.ca</p>
                  <p className="text-gray-500 text-sm">We respond within 24 hours</p>
                </div>
              </a>

              {/* RED insurance box */}
              <div className="bg-red-600 text-white p-6 rounded-lg mb-8">
                <p className="text-lg font-semibold mb-2" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>
                  $5 Million Liability Coverage
                </p>
                <p className="text-sm" style={{ fontFamily: 'Open Sans, sans-serif' }}>
                  WorkSafeBC compliant. Documentation and certificates available on request.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;